<template>
  <v-list-item>
    <v-list-item-icon class="my-auto">
      <v-icon color="indigo">{{ customData.icon }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title v-if="customData.dinheiro">
        {{
          customData.value
            | currency("R$", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
              spaceBetweenAmountAndSymbol: true
            })
        }}
      </v-list-item-title>
      <v-list-item-title v-else> {{ customData.value }} </v-list-item-title>
      <v-list-item-subtitle>
        {{ customData.description }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-icon v-if="customData.actionIcon" class="my-auto">
      <v-icon> {{ customData.actionIcon }}</v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    customData: {
      type: Object,
      default: null
    }
  }
};
</script>
